

import { classesRuntime, statesRuntime } from "./../../../../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_209_0_Center";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_209_0_Center__root","center":"wds_1_209_0_Center__center"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




